<!-- token-handler.component.html -->
<div class="impersonation-container">
  <div class="message">
    Impersonating the user, please wait...
  </div>
</div>
